var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#5F6F7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0968 13C9.93876 13 9 13.9594 9 15.1429V28.8571C9 30.0406 9.93876 31 11.0968 31H32.9032C34.0612 31 35 30.0406 35 28.8571V15.1429C35 13.9594 34.0612 13 32.9032 13H11.0968ZM17.1774 22C18.6336 22 19.8142 20.8008 19.8142 19.3214C19.8142 17.8421 18.6336 16.6429 17.1774 16.6429C15.7211 16.6429 14.5406 17.8421 14.5406 19.3214C14.5406 20.8008 15.7211 22 17.1774 22ZM15.9295 22.1127C14.9246 21.4846 13.5946 21.774 13.1387 22.8795C12.887 23.49 12.682 24.1646 12.6656 24.7679C12.6553 25.1478 12.6848 25.5641 12.7287 25.9497C12.8229 26.7788 13.5421 27.3571 14.3637 27.3571H19.9911C20.8128 27.3571 21.5319 26.7788 21.6262 25.9497C21.67 25.5641 21.6996 25.1478 21.6892 24.7679C21.6729 24.1646 21.4678 23.49 21.2161 22.8795C20.7602 21.774 19.4302 21.4846 18.4254 22.1127L18.329 22.1729C17.6228 22.6144 16.732 22.6144 16.0258 22.1729L15.9295 22.1127ZM23.8871 19.2143C23.8871 18.8592 24.1687 18.5714 24.5161 18.5714H31.2258C31.5732 18.5714 31.8548 18.8592 31.8548 19.2143C31.8548 19.5693 31.5732 19.8571 31.2258 19.8571H24.5161C24.1687 19.8571 23.8871 19.5693 23.8871 19.2143ZM24.5161 21.3571C24.1687 21.3571 23.8871 21.645 23.8871 22C23.8871 22.355 24.1687 22.6429 24.5161 22.6429H31.2258C31.5732 22.6429 31.8548 22.355 31.8548 22C31.8548 21.645 31.5732 21.3571 31.2258 21.3571H24.5161ZM23.8871 24.7857C23.8871 24.4307 24.1687 24.1429 24.5161 24.1429H31.2258C31.5732 24.1429 31.8548 24.4307 31.8548 24.7857C31.8548 25.1408 31.5732 25.4286 31.2258 25.4286H24.5161C24.1687 25.4286 23.8871 25.1408 23.8871 24.7857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsIcon);
export default __webpack_public_path__ + "static/media/details-icon.9598a7494729b602685e90541b206982.svg";
export { ForwardRef as ReactComponent };